import React, { useState } from 'react'
import { GrClose } from "react-icons/gr";
import { Link } from 'react-router-dom';
import cart from '../data/cart.json'


export default function Cartproduct({ item }) {

    const del = () => {
        setToast('')
        cart.pop(item)
    }

    const [toast, setToast] = useState(<div className='flex space-x-2 p-4 my-2 md:mx-0 mx-auto justify-between md:w-full border-2 border-yakam rounded-lg'>
        <div className='flex flex-row'>
            <div className='  w-24 h-32 md:w-32 md:h-40'>
                <img className='object-contain' src={item.Pimg} alt={item.Pimg} />
            </div>
            <div className='flex flex-col justify-between text-shasham'>
                <div>

                    <h1 className='text-xs text-chwaram'>{item.catag}</h1>
                    <div className='flex flex-row space-x-3 '>
                        <p className='text-yakam text-lg'>{item.Ptitle}</p>

                        {item.catag === 'Men\'s Kit' || item.catag === 'Men\'s T-Shirt' || item.catag === 'Men\'s Tracksuit' || item.catag === 'Women\'s Kit' || item.catag === 'Women\'s T-shirt' || item.catag === 'tracksuit' || item.catag === "Men's sport Shoes" || item.catag === "Shoes" ?

                            (
                                <>
                                    <p className='h-full w-1 text-chwaram bg-chwaram'>|</p>
                                    <p>Size: {item.size}</p>
                                </>
                            )
                            :
                            (
                                null
                            )
                        }

                    </div>
                </div>

                <p className='text-c7 text-xl'>{item.price}$</p>
            </div>
        </div>
        <div className='flex justify-end  w-1/4 '>

            <Link to='/cart' onClick={del} className='h-fit'>
                <GrClose className='  mx-auto text-white' />
            </Link>
        </div>
    </div>)
    return (
        <>

            {toast}
        </>


    )
}
